import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ContractGroupsPage } from '@features/admin/contract-groups';
import { useAdminContractGroupStore } from '@features/admin/contract-groups/useAdminContractGroupStore.ts';

const adminContractGroupsSearchSchema = z.object({
  /** Část názvu skupiny. */
  q: z.string().optional(),
  /** Název, zkratka nebo IČO firmy, která ve skupině je. */
  company: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminContractGroupsSearch = z.infer<typeof adminContractGroupsSearchSchema>;

export const Route = createFileRoute('/admin/contract-groups/')({
  validateSearch: search => adminContractGroupsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { q, company, page, size } = ctx.search;
    useAdminContractGroupStore.getState().loadContractGroups({
      q,
      company,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <ContractGroupsPage />;
}
